import styles from './Footer.module.css';
import Redirects from "@/commons/utils/Redirects";
import footerLogo from "@/commons/resources/images/eblcraft/scrittaEBLCraft.png";

import discordLogo from "@/commons/resources/images/footer/discordLogo.png";
import instagramLogo from "@/commons/resources/images/footer/instagramLogo.png";
import tiktokLogo from "@/commons/resources/images/footer/tiktokLogo.png";
import youtubeLogo from "@/commons/resources/images/footer/youtubeLogo.png";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <>
            <div className={styles.footerBackground}>
                <img src={footerLogo} alt="Logo" className={styles.footerLogo} />
                <div className={styles.footerContent}>
                    <div className={styles.footerBox}>
                        <span className={styles.footerFirstTitle}>HAI BISOGNO DI AIUTO?</span>
                        <span className={styles.footerText}>
                            <a onClick={(e) => Redirects.send("/faq", e)}>Consulta le FAQ</a><br/>
                            <a onClick={(e) => Redirects.send("/report", e)}>Richiedi supporto</a><br/>
                            <a onClick={(e) => Redirects.send("/tos", e)}>Consulta i T.O.S.</a><br/>
                        </span>
                    </div>
                    <div className={styles.footerBox}>
                        <span className={styles.footerSecondTitle}>LINKS UTILI</span>
                        <div className={styles.footerLinksContainer}>
                            <div className={styles.footerLinksGroup}>
                                <div className={[styles.footerLinksColumn, styles.footerLinkSpacer].join(' ')}>
                                    <span className={styles.footerLinks} onClick={() => Redirects.send("https://www.eblcraft.it/map/mondo1")}>Mappa Mondo 1</span>
                                    <span className={styles.footerLinks} onClick={() => Redirects.send("https://www.eblcraft.it/map/mondo2")}>Mappa Mondo 2</span>
                                    <span className={styles.footerLinks} onClick={() => Redirects.send("https://twitchlink.erenblaze.it")}>TwitchLink</span>
                                </div>
                            </div>
                            <div className={styles.footerLinksGroup}>
                                <div className={styles.footerLinksColumn}>
                                    <span className={styles.footerLinks} onClick={() => Redirects.send("https://store.eblcraft.it")}>Store</span>
                                    <span className={styles.footerLinks} onClick={() => Redirects.send("https://t.me/newserenblaze")}>Canale News</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className={styles.footerBox}>
                        <span className={styles.footerThirdTitle}>SEGUI EBLCRAFT</span>
                        <div className={styles.socialIcons}>
                            <img src={youtubeLogo} alt="Youtube" className={styles.socialIcon} onClick={(e) =>
                                Redirects.send("https://www.youtube.com/@EBLCraft", e)}/>
                            <img src={instagramLogo} alt="Instagram" className={styles.socialIcon} onClick={(e) =>
                                Redirects.send("https://www.instagram.com/eblcraft/", e)}/>
                            <img src={discordLogo} alt="Discord" className={styles.socialIcon} onClick={(e) =>
                                Redirects.send("https://discord.erenblaze.it", e)}/>
                            <img src={tiktokLogo} alt="TikTOk" className={styles.socialIcon} onClick={(e) =>
                                Redirects.send("https://www.tiktok.com/@eblcraft?lang=it-IT", e)}/>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.footerFooter}>
                <div className={styles.footerFooterLeft}>
                    Not an official Minecraft Server.<br/>
                    Not approved by or associated with Mojang or Microsoft.
                </div>
                <div className={styles.footerFooterCenter}>
                    Copyright © ErenBlaze 2019 - {currentYear}<br/>
                    Made with ❤️ by <a href="https://www.mrliam2614.net" target={"_blank"}>MrLiam2614</a>
                </div>
                <div className={styles.footerFooterRight}>
                    P.IVA 09262890966<br/>
                    <a href={"mailto:supporto@eblcraft.it"}>supporto@eblcraft.it</a>
                </div>
            </div>
        </>
    );
}

export default Footer;
